import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

export function DateForm() {
    const { isFormDisabled, form } = useFieldFormContext();

    return (
        <div className="flex flex-col gap-2">
            <FormField
                name="field_date_options.year_only"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <div className="flex items-center gap-2">
                            <FormControl>
                                <Checkbox
                                    checked={field.value}
                                    onCheckedChange={field.onChange}
                                    id="year_only"
                                    className="w-5 h-5 form-checkbox text-primary"
                                    disabled={isFormDisabled}
                                />
                            </FormControl>
                            <FormLabel
                                className={cn("text-sm font-medium", isFormDisabled && "opacity-50")}
                                htmlFor="year_only"
                            >
                                Year only?
                            </FormLabel>
                        </div>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </div>
    );
}